import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useMapStore } from '../MapStore/UseMapStore';

export function useMapAlerts() {
  const history = useHistory();

  useEffect(() => {
    const unblock = history.block((tx) => {
      const state = useMapStore.getState();
      if (!state.isDirty) return;

      Swal.fire({
        title: 'Are you sure you want to leave?',
        text: 'Your changes will not be saved.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      }).then((result) => {
        if (result.isConfirmed) {
          unblock();
          state.setIsDirty(false);
          useMapStore.getState().resetAllSlices();
          history.push(tx.pathname);
        }
      });

      return false;
    });

    return () => unblock();
  }, [history]);

  // Intercept browser tab closing
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      const state = useMapStore.getState();
      if (!state.isDirty) return;

      event.preventDefault();
      event.returnValue = ''; // Chrome requires this
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, []);
}
